import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import api from '@/axios';
import { GET_SUPPLIER_SUBCONTRACTORS_KEY } from '@/keys';
import type { Subcontractor } from '@/types/core/purchase-planning/subcontractor';

const getProductionDeclarationSubcontractors = async (
  productionDeclarationId: string,
  token?: string,
): Promise<Subcontractor[]> => {
  const response = await api.get<Subcontractor[]>(
    `/production-declarations/${productionDeclarationId}/subcontractors`,
    { params: { token } },
  );
  return response.data;
};

export const useGetProductionDeclarationSubcontractors = (
  productionDeclarationId: string,
  materialId: string,
  commodityOriginId: string,
  token?: string,
): UseQueryResult<Subcontractor[], Error> =>
  useQuery({
    queryKey: [
      ...GET_SUPPLIER_SUBCONTRACTORS_KEY,
      productionDeclarationId,
      token ?? '',
    ],
    queryFn: () =>
      getProductionDeclarationSubcontractors(productionDeclarationId, token),
    enabled: Boolean(
      productionDeclarationId && materialId && commodityOriginId,
    ),
  });
